__turbopack_context__.v({
  "chat": "ComponentChat-module-scss-module__xYIlXa__chat",
  "close": "ComponentChat-module-scss-module__xYIlXa__close",
});
